// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// SVG registry for entry: knowledge-base
import store from './svg-store';
store['lucide/chart-line'] = require('svg-files-path/lucide/chart-line.svg');
store['lucide/chevron-left'] = require('svg-files-path/lucide/chevron-left.svg');
store['lucide/chevron-right'] = require('svg-files-path/lucide/chevron-right.svg');
store['lucide/circle-question-mark'] = require('svg-files-path/lucide/circle-question-mark.svg');
store['lucide/lightbulb'] = require('svg-files-path/lucide/lightbulb.svg');
